export class ContactUs {
    $key: string;
    name: string = null;
    infoTop: string = null;
    infoBottom: string = null;
    emails = new Array<string>();
    addresses = new Array<string>();
    phoneNumbers = new Array<string>();
    website: string = null;
    fax: string = null;
    position: number = null;
}


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/contact-us.ts